import React from 'react';
import BaseModal from './BaseModal';
import { SxProps, Theme } from '@mui/material';

interface GenericFormModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  submitText?: string;
  cancelText?: string;
  submitDisabled?: boolean;
  submitLoading?: boolean;
  children: React.ReactNode;
  width?: string;
  maxWidth?: string;
  sx?: SxProps<Theme>;
  dataTestId?: string;
}

const GenericFormModal: React.FC<GenericFormModalProps> = ({
  open,
  onClose,
  onSubmit,
  title,
  submitText = 'Submit',
  cancelText = 'Cancel',
  submitDisabled = false,
  submitLoading = false,
  children,
  width = '400px',
  maxWidth = '400px',
  sx,
  dataTestId = 'generic-form-modal',
}) => {
  return (
    <BaseModal
      dataTestId={dataTestId}
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      title={title}
      submitText={submitText}
      cancelText={cancelText}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      width={width}
      maxWidthOverride={maxWidth}
      maxWidth="sm"
      sx={sx}
    >
      {children}
    </BaseModal>
  );
};

export default GenericFormModal;
